<template>
  <section class="games">
    <!--    <img id="background-image" src="../../../../assets/images/game/exam/background.png" class="h-100 w-100" alt="">-->
    <div class="exam-container container position-relative overflow-hidden">
      <div>
        <div>
          <router-link class="brand d-flex justify-content-center align-items-center" to="/">
            <img width="30" src="../../../../assets/images/game/exam/kaftar-transparent.png" alt="kaftar" />
            <img src="../../../../assets/images/game/exam/benedito-transparent.png" alt="benedito" />
            <!--            <p class="text-white m-0 ">بندیتو</p>-->
          </router-link>
        </div>
        <div class="top-image position-relative d-flex justify-content-center align-items-center">
          <img class="" src="../../../../assets/images/game/birthday/Asset1.png" alt="Envelope start button game" />
        </div>
        <!-- <div class="bottom-image">
          <img
            class=" "
            src="../../../../assets/images/game/birthday/Asset6.png"
            alt="glass"
          />
        </div> -->
        <div class="shapes-image">
          <ul class="list-unstyled">
            <!-- <li class="">
              <img
                src="../../../../assets/images/game/exam/shape-6.png"
                alt="moving shape "
                class="shape shape-1"
              />
            </li> -->
            <li class="">
              <img src="../../../../assets/images/game/birthday/Asset7.png" alt="moving shape " class="shape shape-2" />
              <img src="../../../../assets/images/game/birthday/Asset5.png" alt="moving shape "
                class="shape shape-2-2" />
            </li>
            <li class="">
              <img src="../../../../assets/images/game/birthday/Asset4.png" alt="moving shape " class="shape shape-3" />
            </li>
            <li class="">
              <img src="../../../../assets/images/game/birthday/Asset3.png" alt="moving shape " class="shape shape-4" />
            </li>
            <li class="">
              <img src="../../../../assets/images/game/birthday/Asset8.png" alt="moving shape " class="shape shape-5" />
              <img src="../../../../assets/images/game/birthday/Asset2.png" alt="moving shape "
                class="shape shape-5-1" />
            </li>
            <!-- <li class="">
              <img
                src="../../../../assets/images/game/exam/shape-4.png"
                alt="moving shape "
                class="shape shape-6"
              />
            </li> -->
          </ul>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <!--      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 350 350" width="350" height="350" preserveAspectRatio="xMidYMid meet" style="width: 100%; height: 100%; transform: translate3d(0px, 0px, 0px); content-visibility: visible;"><defs><clipPath id="__lottie_element_2"><rect width="350" height="350" x="0" y="0"></rect></clipPath></defs><g clip-path="url(#__lottie_element_2)"><g transform="matrix(1,0,0,1,175,175)" opacity="1" style="display: block;"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(254,202,62)" fill-opacity="1" d=" M55.71500015258789,-2.4140000343322754 C55.71699905395508,-2.4140000343322754 55.71900177001953,-2.4140000343322754 55.72100067138672,-2.4140000343322754 C55.72200012207031,-2.4140000343322754 55.72200012207031,-2.4140000343322754 55.722999572753906,-2.4140000343322754 C55.720001220703125,-2.4140000343322754 55.71900177001953,-2.4140000343322754 55.715999603271484,-2.4140000343322754 C55.715999603271484,-2.4140000343322754 55.71500015258789,-2.4140000343322754 55.71500015258789,-2.4140000343322754z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(218,223,243)" fill-opacity="1" d=" M55.70800018310547,-2.4140000343322754 C55.709999084472656,-2.4140000343322754 55.71099853515625,-2.4140000343322754 55.7130012512207,-2.4140000343322754 C55.7140007019043,-2.4140000343322754 55.7140007019043,-2.4140000343322754 55.71500015258789,-2.4140000343322754 C55.7130012512207,-2.4140000343322754 55.71099853515625,-2.4140000343322754 55.70899963378906,-2.4140000343322754 C55.70899963378906,-2.4140000343322754 55.70800018310547,-2.4140000343322754 55.70800018310547,-2.4140000343322754z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(218,223,243)" fill-opacity="1" d=" M55.70899963378906,-2.4140000343322754 C55.71099853515625,-2.4140000343322754 55.7130012512207,-2.4140000343322754 55.71500015258789,-2.4140000343322754 C55.71500015258789,-2.4140000343322754 55.715999603271484,-2.4140000343322754 55.715999603271484,-2.4140000343322754 C55.7140007019043,-2.4140000343322754 55.71099853515625,-2.4140000343322754 55.70899963378906,-2.4140000343322754z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(254,157,151)" fill-opacity="1" d=" M34.77299880981445,23.604999542236328 C34.77299880981445,23.604999542236328 33.0989990234375,20.506000518798828 33.0989990234375,20.506000518798828 C33.0989990234375,20.506000518798828 33.14899826049805,20.506000518798828 33.14899826049805,20.506000518798828 C33.14899826049805,20.506000518798828 33.935001373291016,21.98200035095215 33.935001373291016,21.98200035095215 C33.935001373291016,21.98200035095215 34.77299880981445,23.604999542236328 34.77299880981445,23.604999542236328z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(27,51,112)" fill-opacity="1" d=" M34.525001525878906,-1.5429999828338623 C34.525001525878906,-1.5429999828338623 34.525001525878906,67.54100036621094 34.525001525878906,67.54100036621094 C34.525001525878906,67.54100036621094 -33.194000244140625,67.54100036621094 -33.194000244140625,67.54100036621094 C-33.194000244140625,67.54100036621094 -33.194000244140625,-1.5429999828338623 -33.194000244140625,-1.5429999828338623 C-33.194000244140625,-5.645999908447266 -29.87299919128418,-8.972000122070312 -25.770000457763672,-8.972000122070312 C-25.770000457763672,-8.972000122070312 27.10099983215332,-8.972000122070312 27.10099983215332,-8.972000122070312 C31.20400047302246,-8.972000122070312 34.525001525878906,-5.645999908447266 34.525001525878906,-1.5429999828338623z"></path></g><g opacity="1" transform="matrix(0.9968089461326599,0.0798245295882225,-0.0798245295882225,0.9968089461326599,-0.08869630098342896,-0.07326400279998779)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M-1.430999994277954,-72.20999908447266 C-1.430999994277954,-64.87100219726562 -7.382999897003174,-58.9109992980957 -14.729999542236328,-58.9109992980957 C-22.07699966430664,-58.9109992980957 -28.027999877929688,-64.87100219726562 -28.027999877929688,-72.20999908447266 C-28.027999877929688,-79.55699920654297 -22.07699966430664,-85.51699829101562 -14.729999542236328,-85.51699829101562 C-7.382999897003174,-85.51699829101562 -1.430999994277954,-79.55699920654297 -1.430999994277954,-72.20999908447266z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M33.51300048828125,-72.20999908447266 C33.51300048828125,-64.87100219726562 27.56100082397461,-58.9109992980957 20.214000701904297,-58.9109992980957 C12.866999626159668,-58.9109992980957 6.915999889373779,-64.87100219726562 6.915999889373779,-72.20999908447266 C6.915999889373779,-79.55699920654297 12.866999626159668,-85.51699829101562 20.214000701904297,-85.51699829101562 C27.56100082397461,-85.51699829101562 33.51300048828125,-79.55699920654297 33.51300048828125,-72.20999908447266z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M-16.030000686645508,-56.650001525878906 C-16.030000686645508,-52.987998962402344 -19,-50.01499938964844 -22.666000366210938,-50.01499938964844 C-26.332000732421875,-50.01499938964844 -29.301000595092773,-52.987998962402344 -29.301000595092773,-56.650001525878906 C-29.301000595092773,-60.316001892089844 -26.332000732421875,-63.290000915527344 -22.666000366210938,-63.290000915527344 C-19,-63.290000915527344 -16.030000686645508,-60.316001892089844 -16.030000686645508,-56.650001525878906z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M30.05900001525879,-56.650001525878906 C30.05900001525879,-52.987998962402344 27.09000015258789,-50.01499938964844 23.423999786376953,-50.01499938964844 C19.757999420166016,-50.01499938964844 16.788000106811523,-52.987998962402344 16.788000106811523,-56.650001525878906 C16.788000106811523,-60.316001892089844 19.757999420166016,-63.290000915527344 23.423999786376953,-63.290000915527344 C27.09000015258789,-63.290000915527344 30.05900001525879,-60.316001892089844 30.05900001525879,-56.650001525878906z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(251,131,134)" fill-opacity="1" d=" M11.663999557495117,-28.076000213623047 C11.663999557495117,-28.076000213623047 11.663999557495117,-12.288999557495117 11.663999557495117,-12.288999557495117 C11.663999557495117,-6.500999927520752 7.0329999923706055,-1.9229999780654907 1.2450000047683716,-1.9229999780654907 C-3.7019999027252197,-1.9229999780654907 -7.752999782562256,-5.3429999351501465 -8.859000205993652,-9.973999977111816 C-8.96399974822998,-10.711000442504883 -9.067999839782715,-11.446999549865723 -9.067999839782715,-12.288999557495117 C-9.067999839782715,-12.288999557495117 -9.067999839782715,-28.076000213623047 -9.067999839782715,-28.076000213623047 C-9.067999839782715,-28.076000213623047 11.663999557495117,-28.076000213623047 11.663999557495117,-28.076000213623047z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(247,99,115)" fill-opacity="1" d=" M11.663999557495117,-28.076000213623047 C11.663999557495117,-28.076000213623047 11.663999557495117,-15.8149995803833 11.663999557495117,-15.8149995803833 C5.296999931335449,-12.815999984741211 -2.5429999828338623,-12.710000038146973 -9.067999839782715,-15.49899959564209 C-9.067999839782715,-15.49899959564209 -9.067999839782715,-28.076000213623047 -9.067999839782715,-28.076000213623047 C-9.067999839782715,-28.076000213623047 11.663999557495117,-28.076000213623047 11.663999557495117,-28.076000213623047z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(254,157,151)" fill-opacity="1" d=" M22.145999908447266,-53.15299987792969 C23.445999145507812,-55.263999938964844 26.29199981689453,-55.59400177001953 28.447999954223633,-54.7599983215332 C30.29199981689453,-54.047000885009766 31.39299964904785,-52.25600051879883 31.625999450683594,-50.345001220703125 C31.922000885009766,-47.9109992980957 30.76799964904785,-45.32400131225586 29.43000030517578,-43.347999572753906 C28.270000457763672,-41.63399887084961 26.57699966430664,-40.39099884033203 24.450000762939453,-40.33000183105469 C23.393999099731445,-40.29999923706055 22.288000106811523,-40.35300064086914 21.304000854492188,-40.965999603271484 C21.304000854492188,-40.965999603271484 22.145999908447266,-53.15299987792969 22.145999908447266,-53.15299987792969z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(253,130,133)" fill-opacity="1" d=" M22.67099952697754,-51.04600143432617 C23.464000701904297,-52.33399963378906 25.200000762939453,-52.534000396728516 26.514999389648438,-52.0260009765625 C27.639999389648438,-51.590999603271484 28.31100082397461,-50.49800109863281 28.452999114990234,-49.33300018310547 C28.634000778198242,-47.8489990234375 27.93000030517578,-46.27199935913086 27.11400032043457,-45.06700134277344 C26.4060001373291,-44.02199935913086 25.374000549316406,-43.26300048828125 24.07699966430664,-43.22600173950195 C23.433000564575195,-43.20800018310547 22.757999420166016,-43.2400016784668 22.158000946044922,-43.61399841308594 C22.158000946044922,-43.61399841308594 22.67099952697754,-51.04600143432617 22.67099952697754,-51.04600143432617z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(254,157,151)" fill-opacity="1" d=" M-20.909000396728516,-53.15299987792969 C-22.208999633789062,-55.263999938964844 -25.05500030517578,-55.59400177001953 -27.211000442504883,-54.7599983215332 C-29.05500030517578,-54.047000885009766 -30.1560001373291,-52.25600051879883 -30.388999938964844,-50.345001220703125 C-30.684999465942383,-47.9109992980957 -29.531999588012695,-45.32400131225586 -28.194000244140625,-43.347999572753906 C-27.034000396728516,-41.63399887084961 -25.34000015258789,-40.39099884033203 -23.21299934387207,-40.33000183105469 C-22.156999588012695,-40.29999923706055 -21.051000595092773,-40.35300064086914 -20.066999435424805,-40.965999603271484 C-20.066999435424805,-40.965999603271484 -20.909000396728516,-53.15299987792969 -20.909000396728516,-53.15299987792969z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(253,130,133)" fill-opacity="1" d=" M-21.434999465942383,-51.04600143432617 C-22.22800064086914,-52.33399963378906 -23.96299934387207,-52.534000396728516 -25.277999877929688,-52.0260009765625 C-26.402999877929688,-51.590999603271484 -27.073999404907227,-50.49800109863281 -27.215999603271484,-49.33300018310547 C-27.39699935913086,-47.8489990234375 -26.69300079345703,-46.27199935913086 -25.87700080871582,-45.06700134277344 C-25.16900062561035,-44.02199935913086 -24.136999130249023,-43.26300048828125 -22.84000015258789,-43.22600173950195 C-22.195999145507812,-43.20800018310547 -21.520999908447266,-43.2400016784668 -20.92099952697754,-43.61399841308594 C-20.92099952697754,-43.61399841308594 -21.434999465942383,-51.04600143432617 -21.434999465942383,-51.04600143432617z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(254,157,151)" fill-opacity="1" d=" M-22.422000885009766,-44.00699996948242 C-22.422000885009766,-44.00699996948242 -22.288000106811523,-48.29199981689453 -22.288000106811523,-48.29199981689453 C-22.288000106811523,-48.29199981689453 -21.72599983215332,-65.72599792480469 -21.72599983215332,-65.72599792480469 C-21.554000854492188,-71.052001953125 -17.19499969482422,-75.28500366210938 -11.866000175476074,-75.29900360107422 C1.281999945640564,-75.33399963378906 23.364999771118164,-75.38700103759766 23.5049991607666,-75.33999633789062 C23.5049991607666,-75.33999633789062 23.57200050354004,-44.00699996948242 23.57200050354004,-44.00699996948242 C23.57200050354004,-44.00699996948242 23.57200050354004,-43.939998626708984 23.57200050354004,-43.939998626708984 C28.65999984741211,-8.59000015258789 -26.774999618530273,-8.991999626159668 -22.422000885009766,-44.00699996948242z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0.08362019062042236,0.957305908203125)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M13.91100025177002,-24.966999053955078 C13.91100025177002,-17.827999114990234 8.119000434875488,-12.03600025177002 0.9800000190734863,-12.03600025177002 C-6.158999919891357,-12.03600025177002 -11.951000213623047,-17.827999114990234 -11.951000213623047,-24.966999053955078 C-11.951000213623047,-32.10599899291992 -6.158999919891357,-37.89799880981445 0.9800000190734863,-37.89799880981445 C8.119000434875488,-37.89799880981445 13.91100025177002,-32.10599899291992 13.91100025177002,-24.966999053955078z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(247,99,115)" fill-opacity="1" d=" M5.269999980926514,-41.9370002746582 C5.269999980926514,-40.26599884033203 3.2090001106262207,-38.928001403808594 0.6460000276565552,-38.928001403808594 C-2.0280001163482666,-38.928001403808594 -4.0329999923706055,-40.26599884033203 -4.0329999923706055,-41.9370002746582 C-4.0329999923706055,-42.77199935913086 -3.5320000648498535,-43.551998138427734 -2.752000093460083,-44.053001403808594 C-2.752000093460083,-44.053001403808594 -2.752000093460083,-50.23699951171875 -2.752000093460083,-50.23699951171875 C-2.752000093460083,-52.02000045776367 -1.246999979019165,-53.46699905395508 0.5910000205039978,-53.46699905395508 C2.484999895095825,-53.46699905395508 3.989000082015991,-52.02000045776367 3.989000082015991,-50.23699951171875 C3.989000082015991,-50.23699951171875 3.989000082015991,-44.053001403808594 3.989000082015991,-44.053001403808594 C4.769000053405762,-43.551998138427734 5.269999980926514,-42.77199935913086 5.269999980926514,-41.9370002746582z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(235,238,247)" stroke-opacity="1" stroke-width="0.881" d=" M23.674999237060547,-48.86800003051758 C23.674999237060547,-48.86800003051758 23.674999237060547,-42.23899841308594 23.674999237060547,-42.23899841308594 C23.674999237060547,-40.388999938964844 22.184999465942383,-38.92399978637695 20.361000061035156,-38.92399978637695 C20.361000061035156,-38.92399978637695 7.461999893188477,-38.92399978637695 7.461999893188477,-38.92399978637695 C5.638000011444092,-38.92399978637695 4.146999835968018,-40.388999938964844 4.146999835968018,-42.23899841308594 C4.146999835968018,-42.23899841308594 4.146999835968018,-48.86800003051758 4.146999835968018,-48.86800003051758 C4.146999835968018,-50.71799850463867 5.638000011444092,-52.18299865722656 7.461999893188477,-52.18299865722656 C7.461999893188477,-52.18299865722656 20.361000061035156,-52.18299865722656 20.361000061035156,-52.18299865722656 C22.184999465942383,-52.18299865722656 23.674999237060547,-50.71799850463867 23.674999237060547,-48.86800003051758z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(235,238,247)" stroke-opacity="1" stroke-width="0.881" d=" M-2.6549999713897705,-48.86800003051758 C-2.6549999713897705,-48.86800003051758 -2.6549999713897705,-42.23899841308594 -2.6549999713897705,-42.23899841308594 C-2.6549999713897705,-40.388999938964844 -4.144999980926514,-38.92399978637695 -5.968999862670898,-38.92399978637695 C-5.968999862670898,-38.92399978637695 -18.868000030517578,-38.92399978637695 -18.868000030517578,-38.92399978637695 C-20.691999435424805,-38.92399978637695 -22.183000564575195,-40.388999938964844 -22.183000564575195,-42.23899841308594 C-22.183000564575195,-42.23899841308594 -22.183000564575195,-48.86800003051758 -22.183000564575195,-48.86800003051758 C-22.183000564575195,-50.71799850463867 -20.691999435424805,-52.18299865722656 -18.868000030517578,-52.18299865722656 C-18.868000030517578,-52.18299865722656 -5.968999862670898,-52.18299865722656 -5.968999862670898,-52.18299865722656 C-4.144999980926514,-52.18299865722656 -2.6549999713897705,-50.71799850463867 -2.6549999713897705,-48.86800003051758z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(235,238,247)" stroke-opacity="1" stroke-width="0.881" d=" M-2.6549999713897705,-46.198001861572266 C-2.6549999713897705,-46.198001861572266 3.989000082015991,-46.34199905395508 3.989000082015991,-46.34199905395508"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(235,238,247)" stroke-opacity="1" stroke-width="1.018" d=" M22.67099952697754,-51.04600143432617 C22.67099952697754,-51.04600143432617 26.48900032043457,-56.652000427246094 26.48900032043457,-56.652000427246094"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(235,238,247)" stroke-opacity="1" stroke-width="1.018" d=" M-21.434999465942383,-51.04600143432617 C-21.434999465942383,-51.04600143432617 -24.983999252319336,-56.45399856567383 -24.983999252319336,-56.45399856567383"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(208,68,94)" stroke-opacity="1" stroke-width="0.833" d=" M-3.50600004196167,-32.20399856567383 C-0.7559999823570251,-30.398000717163086 1.9930000305175781,-30.398000717163086 4.743000030517578,-32.20399856567383"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(24,30,30)" stroke-opacity="1" stroke-width="0.833" d=" M-4.333000183105469,-55.75299835205078 C-6.89900016784668,-56.98699951171875 -9.461000442504883,-57.06100082397461 -12.015999794006348,-55.481998443603516"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path stroke-linecap="round" stroke-linejoin="round" fill-opacity="0" stroke="rgb(24,30,30)" stroke-opacity="1" stroke-width="0.833" d=" M13.159000396728516,-55.75299835205078 C10.593000411987305,-56.98699951171875 8.031000137329102,-57.06100082397461 5.47599983215332,-55.481998443603516"></path></g><g opacity="1" transform="matrix(1,0,0,1,0.20953083038330078,2.3932647705078125)"><path fill="rgb(24,30,30)" fill-opacity="1" d=" M9.770000457763672,-45.284000396728516 C9.770000457763672,-44.59600067138672 9.206000328063965,-44.03200149536133 8.517999649047852,-44.03200149536133 C7.89300012588501,-44.03200149536133 7.329999923706055,-44.59600067138672 7.329999923706055,-45.284000396728516 C7.329999923706055,-45.909000396728516 7.89300012588501,-46.47200012207031 8.517999649047852,-46.47200012207031 C9.206000328063965,-46.47200012207031 9.770000457763672,-45.909000396728516 9.770000457763672,-45.284000396728516z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0.20953130722045898,2.393268585205078)"><path fill="rgb(24,30,30)" fill-opacity="1" d=" M-7.829999923706055,-45.584999084472656 C-7.829999923706055,-44.89699935913086 -7.267000198364258,-44.33300018310547 -6.578999996185303,-44.33300018310547 C-5.953999996185303,-44.33300018310547 -5.389999866485596,-44.89699935913086 -5.389999866485596,-45.584999084472656 C-5.389999866485596,-46.209999084472656 -5.953999996185303,-46.77299880981445 -6.578999996185303,-46.77299880981445 C-7.267000198364258,-46.77299880981445 -7.829999923706055,-46.209999084472656 -7.829999923706055,-45.584999084472656z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M23.097999572753906,-81.30599975585938 C23.097999572753906,-81.30599975585938 23.097999572753906,-90.78600311279297 23.097999572753906,-90.78600311279297 C23.097999572753906,-91.85600280761719 22.229999542236328,-92.7239990234375 21.15999984741211,-92.7239990234375 C21.15999984741211,-92.7239990234375 3.934999942779541,-92.7239990234375 3.934999942779541,-92.7239990234375 C3.934999942779541,-92.7239990234375 3.934999942779541,-81.30599975585938 3.934999942779541,-81.30599975585938 C3.934999942779541,-81.30599975585938 23.097999572753906,-81.30599975585938 23.097999572753906,-81.30599975585938z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M28.697999954223633,-86.00599670410156 C28.697999954223633,-86.00599670410156 28.697999954223633,-76.21600341796875 28.697999954223633,-76.21600341796875 C28.697999954223633,-69.0770034790039 22.90999984741211,-63.290000915527344 15.770999908447266,-63.290000915527344 C15.770999908447266,-63.290000915527344 -0.4189999997615814,-63.290000915527344 -0.4189999997615814,-63.290000915527344 C-7.558000087738037,-63.290000915527344 -13.345999717712402,-69.0770034790039 -13.345999717712402,-76.21600341796875 C-13.345999717712402,-76.21600341796875 -13.345999717712402,-87.94400024414062 -13.345999717712402,-87.94400024414062 C-13.345999717712402,-87.94400024414062 26.76099967956543,-87.94400024414062 26.76099967956543,-87.94400024414062 C27.83099937438965,-87.94400024414062 28.697999954223633,-87.07599639892578 28.697999954223633,-86.00599670410156z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(66,22,57)" fill-opacity="1" d=" M15.92300033569336,-68.93800354003906 C15.92300033569336,-68.93800354003906 -0.2669999897480011,-68.93800354003906 -0.2669999897480011,-68.93800354003906 C-7.406000137329102,-68.93800354003906 -13.194999694824219,-74.72599792480469 -13.194999694824219,-81.86499786376953 C-13.194999694824219,-81.86499786376953 -13.194999694824219,-82.51100158691406 -13.194999694824219,-82.51100158691406 C-13.194999694824219,-82.51100158691406 -13.343999862670898,-82.51100158691406 -13.343999862670898,-82.51100158691406 C-13.343999862670898,-82.51100158691406 -13.343999862670898,-76.21700286865234 -13.343999862670898,-76.21700286865234 C-13.343999862670898,-69.0780029296875 -7.559999942779541,-63.28900146484375 -0.42100000381469727,-63.28900146484375 C-0.42100000381469727,-63.28900146484375 15.77299976348877,-63.28900146484375 15.77299976348877,-63.28900146484375 C22.91200065612793,-63.28900146484375 28.69700050354004,-69.0780029296875 28.69700050354004,-76.21700286865234 C28.69700050354004,-76.21700286865234 28.69700050354004,-79.86799621582031 28.69700050354004,-79.86799621582031 C27.73900032043457,-73.6780014038086 22.385000228881836,-68.93800354003906 15.92300033569336,-68.93800354003906z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(82,27,66)" fill-opacity="1" d=" M10.484000205993652,-87.55699920654297 C10.484000205993652,-81.95500183105469 5.1479997634887695,-77.41300201416016 -1.430999994277954,-77.41300201416016 C-8.010000228881836,-77.41300201416016 -13.345999717712402,-81.95500183105469 -13.345999717712402,-87.55699920654297 C-13.345999717712402,-93.15899658203125 -8.010000228881836,-97.7020034790039 -1.430999994277954,-97.7020034790039 C5.1479997634887695,-97.7020034790039 10.484000205993652,-93.15899658203125 10.484000205993652,-87.55699920654297z"></path></g></g></g><g opacity="1" transform="matrix(0.9872561097145081,0.15913960337638855,-0.15913960337638855,0.9872561097145081,0.8067417144775391,-4.740200042724609)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(27,51,112)" fill-opacity="1" d=" M71.94300079345703,-52.189998626708984 C67.50800323486328,-54.69499969482422 61.88800048828125,-53.29899978637695 59.13999938964844,-49.0099983215332 C59.13999938964844,-49.0099983215332 22.312000274658203,-2.7209999561309814 22.312000274658203,-2.7209999561309814 C20.933000564575195,-0.43299999833106995 20.61199951171875,2.187999963760376 21.20599937438965,4.580999851226807 C21.78700065612793,6.922999858856201 23.297000885009766,9.08899974822998 25.53499984741211,10.479999542236328 C30.111000061035156,13.236000061035156 36.018001556396484,11.770000457763672 38.736000061035156,7.256999969482422 C38.736000061035156,7.256999969482422 75.30799865722656,-38.65700149536133 75.30799865722656,-38.65700149536133 C78.27899932861328,-43.29800033569336 76.74099731445312,-49.48099899291992 71.94300079345703,-52.189998626708984 C71.94300079345703,-52.189998626708984 71.94300079345703,-52.189998626708984 71.94300079345703,-52.189998626708984z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(251,131,134)" fill-opacity="1" d=" M78.86199951171875,-71.89900207519531 C78.86199951171875,-71.89900207519531 80.4520034790039,-62.566001892089844 80.4520034790039,-62.566001892089844 C80.4520034790039,-62.566001892089844 76.7020034790039,-61.926998138427734 76.7020034790039,-61.926998138427734 C74.12100219726562,-61.48699951171875 71.6719970703125,-63.222999572753906 71.23200225830078,-65.80400085449219 C71.23200225830078,-65.80400085449219 69.48100280761719,-76.08100128173828 69.48100280761719,-76.08100128173828 C69.3489990234375,-76.85600280761719 69.87000274658203,-77.59100341796875 70.6449966430664,-77.7229995727539 C70.6449966430664,-77.7229995727539 70.6449966430664,-77.7229995727539 70.6449966430664,-77.7229995727539 C74.52200317382812,-78.38400268554688 78.20099639892578,-75.7760009765625 78.86199951171875,-71.89900207519531z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(252,144,142)" fill-opacity="1" d=" M73.29199981689453,-45.361000061035156 C70.03099822998047,-47.43199920654297 66.9540023803711,-49.80799865722656 63.84199905395508,-52.095001220703125 C63.42499923706055,-52.402000427246094 63.00699996948242,-52.715999603271484 62.59299850463867,-53.0369987487793 C62.59299850463867,-53.0369987487793 67.61299896240234,-59.229000091552734 67.61299896240234,-59.229000091552734 C67.61299896240234,-59.229000091552734 72.08100128173828,-64.68099975585938 72.08100128173828,-64.68099975585938 C72.08100128173828,-64.68099975585938 82.94200134277344,-77.98799896240234 82.94200134277344,-77.98799896240234 C86.28199768066406,-82.06199645996094 92.33699798583984,-82.66200256347656 96.46399688720703,-79.3280029296875 C100.58999633789062,-75.99400329589844 101.19599914550781,-69.88500213623047 97.80400085449219,-65.80599975585938 C97.80400085449219,-65.80599975585938 86.41999816894531,-51.91899871826172 86.41999816894531,-51.91899871826172 C86.41999816894531,-51.91899871826172 81.95700073242188,-46.41600036621094 81.95700073242188,-46.41600036621094 C81.95700073242188,-46.41600036621094 77.69999694824219,-41.1619987487793 77.69999694824219,-41.1619987487793 C76.47100067138672,-42.797000885009766 75.02200317382812,-44.262001037597656 73.29199981689453,-45.361000061035156z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(27,51,112)" fill-opacity="1" d=" M78.56999969482422,-42.27399826049805 C78.56999969482422,-42.27399826049805 65.91799926757812,-26.621999740600586 65.91799926757812,-26.621999740600586 C64.2249984741211,-24.555999755859375 61.86399841308594,-23.37299919128418 59.40999984741211,-23.1299991607666 C57.00899887084961,-22.892000198364258 54.46200180053711,-23.58799934387207 52.4010009765625,-25.229999542236328 C48.26900100708008,-28.615999221801758 47.66899871826172,-34.67300033569336 51.00899887084961,-38.74700164794922 C51.00899887084961,-38.74700164794922 64.05000305175781,-54.87300109863281 64.05000305175781,-54.87300109863281 C64.05000305175781,-54.87300109863281 78.56999969482422,-42.27399826049805 78.56999969482422,-42.27399826049805z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(27,51,112)" fill-opacity="1" d=" M81.05500030517578,-45.303001403808594 C81.05500030517578,-45.303001403808594 83.90699768066406,-48.81999969482422 83.90699768066406,-48.81999969482422 C83.90699768066406,-48.81999969482422 69.14099884033203,-61.09400177001953 69.14099884033203,-61.09400177001953 C69.14099884033203,-61.09400177001953 66.28900146484375,-57.62799835205078 66.28900146484375,-57.62799835205078 C66.28900146484375,-57.62799835205078 81.05500030517578,-45.303001403808594 81.05500030517578,-45.303001403808594z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(251,131,134)" fill-opacity="1" d=" M64.05000305175781,-54.87300109863281 C64.05000305175781,-54.87300109863281 65.51000213623047,-56.66999816894531 65.51000213623047,-56.66999816894531 C65.51000213623047,-56.66999816894531 80.25599670410156,-44.327999114990234 80.25599670410156,-44.327999114990234 C80.25599670410156,-44.327999114990234 78.56999969482422,-42.27399826049805 78.56999969482422,-42.27399826049805 C78.56999969482422,-42.27399826049805 64.05000305175781,-54.87300109863281 64.05000305175781,-54.87300109863281z"></path></g></g></g><g opacity="1" transform="matrix(0.9872561097145081,-0.15913960337638855,0.15913960337638855,0.9872561097145081,-0.6885948181152344,-4.876828670501709)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(27,51,112)" fill-opacity="1" d=" M-71.94300079345703,-52.189998626708984 C-67.50800323486328,-54.69499969482422 -61.88800048828125,-53.29899978637695 -59.13999938964844,-49.0099983215332 C-59.13999938964844,-49.0099983215332 -22.312000274658203,-2.7209999561309814 -22.312000274658203,-2.7209999561309814 C-20.933000564575195,-0.43299999833106995 -20.61199951171875,2.187999963760376 -21.20599937438965,4.580999851226807 C-21.78700065612793,6.922999858856201 -23.297000885009766,9.08899974822998 -25.53499984741211,10.479999542236328 C-30.111000061035156,13.236000061035156 -36.018001556396484,11.770000457763672 -38.736000061035156,7.256999969482422 C-38.736000061035156,7.256999969482422 -75.30799865722656,-38.65700149536133 -75.30799865722656,-38.65700149536133 C-78.27899932861328,-43.29800033569336 -76.74099731445312,-49.48099899291992 -71.94300079345703,-52.189998626708984 C-71.94300079345703,-52.189998626708984 -71.94300079345703,-52.189998626708984 -71.94300079345703,-52.189998626708984z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(251,131,134)" fill-opacity="1" d=" M-78.86199951171875,-71.89900207519531 C-78.86199951171875,-71.89900207519531 -80.4520034790039,-62.566001892089844 -80.4520034790039,-62.566001892089844 C-80.4520034790039,-62.566001892089844 -76.7020034790039,-61.926998138427734 -76.7020034790039,-61.926998138427734 C-74.12100219726562,-61.48699951171875 -71.6719970703125,-63.222999572753906 -71.23200225830078,-65.80400085449219 C-71.23200225830078,-65.80400085449219 -69.48100280761719,-76.08100128173828 -69.48100280761719,-76.08100128173828 C-69.3489990234375,-76.85600280761719 -69.87000274658203,-77.59100341796875 -70.6449966430664,-77.7229995727539 C-70.6449966430664,-77.7229995727539 -70.6449966430664,-77.7229995727539 -70.6449966430664,-77.7229995727539 C-74.52200317382812,-78.38400268554688 -78.20099639892578,-75.7760009765625 -78.86199951171875,-71.89900207519531z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(252,144,142)" fill-opacity="1" d=" M-73.29199981689453,-45.361000061035156 C-70.03099822998047,-47.43199920654297 -66.9540023803711,-49.80799865722656 -63.84199905395508,-52.095001220703125 C-63.42499923706055,-52.402000427246094 -63.00699996948242,-52.715999603271484 -62.59299850463867,-53.0369987487793 C-62.59299850463867,-53.0369987487793 -67.61299896240234,-59.229000091552734 -67.61299896240234,-59.229000091552734 C-67.61299896240234,-59.229000091552734 -72.08100128173828,-64.68099975585938 -72.08100128173828,-64.68099975585938 C-72.08100128173828,-64.68099975585938 -82.94200134277344,-77.98799896240234 -82.94200134277344,-77.98799896240234 C-86.28199768066406,-82.06199645996094 -92.33699798583984,-82.66200256347656 -96.46399688720703,-79.3280029296875 C-100.58999633789062,-75.99400329589844 -101.19599914550781,-69.88500213623047 -97.80400085449219,-65.80599975585938 C-97.80400085449219,-65.80599975585938 -86.41999816894531,-51.91899871826172 -86.41999816894531,-51.91899871826172 C-86.41999816894531,-51.91899871826172 -81.95700073242188,-46.41600036621094 -81.95700073242188,-46.41600036621094 C-81.95700073242188,-46.41600036621094 -77.69999694824219,-41.1619987487793 -77.69999694824219,-41.1619987487793 C-76.47100067138672,-42.797000885009766 -75.02200317382812,-44.262001037597656 -73.29199981689453,-45.361000061035156z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(27,51,112)" fill-opacity="1" d=" M-78.56999969482422,-42.27399826049805 C-78.56999969482422,-42.27399826049805 -65.91799926757812,-26.621999740600586 -65.91799926757812,-26.621999740600586 C-64.2249984741211,-24.555999755859375 -61.86399841308594,-23.37299919128418 -59.40999984741211,-23.1299991607666 C-57.00899887084961,-22.892000198364258 -54.46200180053711,-23.58799934387207 -52.4010009765625,-25.229999542236328 C-48.26900100708008,-28.615999221801758 -47.66899871826172,-34.67300033569336 -51.00899887084961,-38.74700164794922 C-51.00899887084961,-38.74700164794922 -64.05000305175781,-54.87300109863281 -64.05000305175781,-54.87300109863281 C-64.05000305175781,-54.87300109863281 -78.56999969482422,-42.27399826049805 -78.56999969482422,-42.27399826049805z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(27,51,112)" fill-opacity="1" d=" M-81.05500030517578,-45.303001403808594 C-81.05500030517578,-45.303001403808594 -83.90699768066406,-48.81999969482422 -83.90699768066406,-48.81999969482422 C-83.90699768066406,-48.81999969482422 -69.14099884033203,-61.09400177001953 -69.14099884033203,-61.09400177001953 C-69.14099884033203,-61.09400177001953 -66.28900146484375,-57.62799835205078 -66.28900146484375,-57.62799835205078 C-66.28900146484375,-57.62799835205078 -81.05500030517578,-45.303001403808594 -81.05500030517578,-45.303001403808594z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(251,131,134)" fill-opacity="1" d=" M-64.05000305175781,-54.87300109863281 C-64.05000305175781,-54.87300109863281 -65.51000213623047,-56.66999816894531 -65.51000213623047,-56.66999816894531 C-65.51000213623047,-56.66999816894531 -80.25599670410156,-44.327999114990234 -80.25599670410156,-44.327999114990234 C-80.25599670410156,-44.327999114990234 -78.56999969482422,-42.27399826049805 -78.56999969482422,-42.27399826049805 C-78.56999969482422,-42.27399826049805 -64.05000305175781,-54.87300109863281 -64.05000305175781,-54.87300109863281z"></path></g></g></g></g><g transform="matrix(1,0,0,1,175,175)" opacity="1" style="display: block;"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(118,192,69)" fill-opacity="1" d=" M71.79900360107422,82.34100341796875 C71.79900360107422,82.34100341796875 71.79900360107422,84.54199981689453 71.79900360107422,84.54199981689453 C71.79900360107422,87.19400024414062 69.64900207519531,89.34400177001953 66.99700164794922,89.34400177001953 C66.99700164794922,89.34400177001953 -65.76000213623047,89.34400177001953 -65.76000213623047,89.34400177001953 C-68.41200256347656,89.34400177001953 -70.56199645996094,87.19400024414062 -70.56199645996094,84.54199981689453 C-70.56199645996094,84.54199981689453 -70.56199645996094,82.34100341796875 -70.56199645996094,82.34100341796875 C-70.56199645996094,79.68900299072266 -68.41200256347656,77.53900146484375 -65.76000213623047,77.53900146484375 C-65.76000213623047,77.53900146484375 66.99700164794922,77.53900146484375 66.99700164794922,77.53900146484375 C69.64900207519531,77.53900146484375 71.79900360107422,79.68900299072266 71.79900360107422,82.34100341796875z"></path></g><g opacity="1" transform="matrix(0.99994295835495,-0.010679223574697971,0.010679223574697971,0.99994295835495,-0.8122143745422363,-0.30031585693359375)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(254,202,62)" fill-opacity="1" d=" M36.15800094604492,37.76300048828125 C36.15800094604492,37.76300048828125 36.15800094604492,70.3949966430664 36.15800094604492,70.3949966430664 C36.15800094604492,74.35900115966797 32.93199920654297,77.53900146484375 28.968000411987305,77.53900146484375 C28.968000411987305,77.53900146484375 -31.086999893188477,77.53900146484375 -31.086999893188477,77.53900146484375 C-35.005001068115234,77.53900146484375 -38.23099899291992,74.35900115966797 -38.23099899291992,70.3949966430664 C-38.23099899291992,70.3949966430664 -38.23099899291992,37.76300048828125 -38.23099899291992,37.76300048828125 C-38.23099899291992,37.76300048828125 36.15800094604492,37.76300048828125 36.15800094604492,37.76300048828125z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(252,178,31)" fill-opacity="1" d=" M36.14799880981445,44.26900100708008 C36.14799880981445,44.26900100708008 36.14799880981445,37.74700164794922 36.14799880981445,37.74700164794922 C36.14799880981445,37.74700164794922 -38.22999954223633,37.74700164794922 -38.22999954223633,37.74700164794922 C-38.22999954223633,37.74700164794922 -38.22999954223633,44.26900100708008 -38.22999954223633,44.26900100708008 C-38.22999954223633,44.26900100708008 36.14799880981445,44.26900100708008 36.14799880981445,44.26900100708008z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(255,104,102)" fill-opacity="1" d=" M5.050000190734863,38.3120002746582 C5.050000190734863,38.3120002746582 5.050000190734863,77.5510025024414 5.050000190734863,77.5510025024414 C5.050000190734863,77.5510025024414 -5.340000152587891,77.5510025024414 -5.340000152587891,77.5510025024414 C-5.340000152587891,77.5510025024414 -5.340000152587891,38.3120002746582 -5.340000152587891,38.3120002746582"></path></g><g opacity="1" transform="matrix(0.9999848008155823,0.005516448523849249,-0.005516448523849249,0.9999848008155823,0.20788812637329102,-0.11950302124023438)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(255,104,102)" fill-opacity="1" d=" M24.8439998626709,14.765999794006348 C24.8439998626709,14.765999794006348 21.48200035095215,15.734000205993652 17.320999145507812,17.302000045776367 C11.218000411987305,19.597999572753906 3.4059998989105225,23.187000274658203 2.006999969482422,26.895000457763672 C2.006999969482422,26.895000457763672 -1.0440000295639038,26.308000564575195 -1.0440000295639038,26.308000564575195 C-1.0440000295639038,26.308000564575195 4.854000091552734,10.223999977111816 15.527000427246094,7.236000061035156 C17.413000106811523,6.7129998207092285 19.433000564575195,7.406000137329102 20.591999053955078,8.980999946594238 C20.591999053955078,8.980999946594238 24.8439998626709,14.765999794006348 24.8439998626709,14.765999794006348z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(241,70,66)" fill-opacity="1" d=" M19.433000564575195,26.895000457763672 C10.717000007629395,33.25199890136719 9.190999984741211,27.72100067138672 9.190999984741211,27.72100067138672 C9.190999984741211,27.72100067138672 17.454999923706055,21.36400032043457 17.320999145507812,17.302000045776367 C21.48200035095215,15.734000205993652 24.8439998626709,14.765999794006348 24.8439998626709,14.765999794006348 C24.8439998626709,14.765999794006348 28.14299964904785,20.538000106811523 19.433000564575195,26.895000457763672z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(255,104,102)" fill-opacity="1" d=" M-22.562999725341797,14.765999794006348 C-22.562999725341797,14.765999794006348 -19.201000213623047,15.734000205993652 -15.039999961853027,17.302000045776367 C-8.937000274658203,19.597999572753906 -1.125,23.187000274658203 0.27399998903274536,26.895000457763672 C0.27399998903274536,26.895000457763672 3.3259999752044678,26.308000564575195 3.3259999752044678,26.308000564575195 C3.3259999752044678,26.308000564575195 -2.572000026702881,10.223999977111816 -13.244999885559082,7.236000061035156 C-15.130999565124512,6.7129998207092285 -17.150999069213867,7.406000137329102 -18.309999465942383,8.980999946594238 C-18.309999465942383,8.980999946594238 -22.562999725341797,14.765999794006348 -22.562999725341797,14.765999794006348z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(241,70,66)" fill-opacity="1" d=" M-17.152000427246094,26.895000457763672 C-8.435999870300293,33.25199890136719 -6.908999919891357,27.72100067138672 -6.908999919891357,27.72100067138672 C-6.908999919891357,27.72100067138672 -15.173999786376953,21.36400032043457 -15.039999961853027,17.302000045776367 C-19.201000213623047,15.734000205993652 -22.562999725341797,14.765999794006348 -22.562999725341797,14.765999794006348 C-22.562999725341797,14.765999794006348 -25.86199951171875,20.538000106811523 -17.152000427246094,26.895000457763672z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(254,202,62)" fill-opacity="1" d=" M40.86399841308594,27.88800048828125 C40.86399841308594,27.88800048828125 40.86399841308594,35.40700149536133 40.86399841308594,35.40700149536133 C40.86399841308594,37.00600051879883 39.56800079345703,38.301998138427734 37.96900177001953,38.301998138427734 C37.96900177001953,38.301998138427734 -40.05099868774414,38.301998138427734 -40.05099868774414,38.301998138427734 C-41.650001525878906,38.301998138427734 -42.94599914550781,37.00600051879883 -42.94599914550781,35.40700149536133 C-42.94599914550781,35.40700149536133 -42.94599914550781,27.88800048828125 -42.94599914550781,27.88800048828125 C-42.94599914550781,26.288999557495117 -41.650001525878906,24.993000030517578 -40.05099868774414,24.993000030517578 C-40.05099868774414,24.993000030517578 37.96900177001953,24.993000030517578 37.96900177001953,24.993000030517578 C39.56800079345703,24.993000030517578 40.86399841308594,26.288999557495117 40.86399841308594,27.88800048828125z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(255,104,102)" fill-opacity="1" d=" M-5.340000152587891,38.3120002746582 C-5.340000152587891,38.3120002746582 -5.340000152587891,24.97800064086914 -5.340000152587891,24.97800064086914 C-5.340000152587891,24.97800064086914 5.050000190734863,24.97800064086914 5.050000190734863,24.97800064086914 C5.050000190734863,24.97800064086914 5.050000190734863,38.3120002746582 5.050000190734863,38.3120002746582"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(241,70,66)" fill-opacity="1" d=" M5.050000190734863,38.3120002746582 C5.050000190734863,38.3120002746582 5.050000190734863,44.26900100708008 5.050000190734863,44.26900100708008 C5.050000190734863,44.26900100708008 -5.340000152587891,44.26900100708008 -5.340000152587891,44.26900100708008 C-5.340000152587891,44.26900100708008 -5.340000152587891,38.3120002746582 -5.340000152587891,38.3120002746582 C-5.340000152587891,38.3120002746582 5.050000190734863,38.3120002746582 5.050000190734863,38.3120002746582z"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(0.9870719313621521,-0.16027787327766418,0.16027787327766418,0.9870719313621521,-12.606184005737305,0.30072021484375)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(78,166,236)" fill-opacity="1" d=" M1.0149999856948853,78.44100189208984 C1.0149999856948853,78.44100189208984 0.9629999995231628,78.5979995727539 0.9629999995231628,78.5979995727539 C0.9629999995231628,78.5979995727539 -2.3310000896453857,87.01499938964844 -2.3310000896453857,87.01499938964844 C-2.3310000896453857,87.01499938964844 -5.729000091552734,95.85099792480469 -5.729000091552734,95.85099792480469 C-6.513000011444092,97.99400329589844 -7.559000015258789,97.99400329589844 -7.873000144958496,97.26200103759766 C-7.873000144958496,97.26200103759766 -9.493000030517578,93.60199737548828 -9.493000030517578,93.60199737548828 C-9.649999618530273,93.13200378417969 -10.17300033569336,92.9229965209961 -10.644000053405762,93.13200378417969 C-10.644000053405762,93.13200378417969 -14.303000450134277,94.75299835205078 -14.303000450134277,94.75299835205078 C-15.03499984741211,95.06700134277344 -15.767000198364258,94.38700103759766 -15.505999565124512,93.65499877929688 C-15.505999565124512,93.65499877929688 -11.428000450134277,83.2509994506836 -11.428000450134277,83.2509994506836 C-11.428000450134277,83.2509994506836 -8.185999870300293,74.88600158691406 -8.185999870300293,74.88600158691406 C-8.185999870300293,74.88600158691406 0.9110000133514404,78.44100189208984 0.9110000133514404,78.44100189208984 C0.9110000133514404,78.44100189208984 1.0149999856948853,78.44100189208984 1.0149999856948853,78.44100189208984z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(60,144,220)" fill-opacity="1" d=" M-5.539000034332275,75.91300201416016 C-5.539000034332275,75.91300201416016 -12.559000015258789,93.99199676513672 -12.559000015258789,93.99199676513672 C-12.559000015258789,93.99199676513672 -10.635000228881836,93.13400268554688 -10.635000228881836,93.13400268554688 C-10.187999725341797,92.93499755859375 -9.664999961853027,93.13800048828125 -9.470000267028809,93.58599853515625 C-9.470000267028809,93.58599853515625 -8.595000267028809,95.5979995727539 -8.595000267028809,95.5979995727539 C-8.595000267028809,95.5979995727539 -1.5520000457763672,77.46099853515625 -1.5520000457763672,77.46099853515625 C-1.5520000457763672,77.46099853515625 -5.539000034332275,75.91300201416016 -5.539000034332275,75.91300201416016z"></path></g></g><g opacity="0.15" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(24,30,30)" fill-opacity="1" d=" M0.9629999995231628,78.5979995727539 C0.9629999995231628,78.5979995727539 -2.3310000896453857,87.01499938964844 -2.3310000896453857,87.01499938964844 C-3.115000009536743,85.96900177001953 -3.742000102996826,84.66300201416016 -4.264999866485596,83.45999908447266 C-4.5269999504089355,82.83300018310547 -4.945000171661377,81.89199829101562 -5.258999824523926,81.36900329589844 C-5.886000156402588,81.4739990234375 -6.879000186920166,81.89199829101562 -7.611000061035156,82.15299987792969 C-8.918000221252441,82.6240005493164 -10.22599983215332,83.14600372314453 -11.428000450134277,83.2509994506836 C-11.428000450134277,83.2509994506836 -8.185999870300293,74.88600158691406 -8.185999870300293,74.88600158691406 C-8.185999870300293,74.88600158691406 0.9110000133514404,78.44100189208984 0.9110000133514404,78.44100189208984 C0.9110000133514404,78.44100189208984 0.9629999995231628,78.44100189208984 0.9629999995231628,78.44100189208984"></path></g></g><g opacity="1" transform="matrix(0.9870719313621521,0.16027787327766418,-0.16027787327766418,0.9870719313621521,12.41722583770752,-0.02264404296875)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(78,166,236)" fill-opacity="1" d=" M16.229000091552734,94.75299835205078 C16.229000091552734,94.75299835205078 12.569000244140625,93.13200378417969 12.569000244140625,93.13200378417969 C12.098999977111816,92.9229965209961 11.576000213623047,93.13200378417969 11.366999626159668,93.60199737548828 C11.366999626159668,93.60199737548828 9.79800033569336,97.26200103759766 9.79800033569336,97.26200103759766 C9.484000205993652,97.99400329589844 8.439000129699707,97.99400329589844 7.65500020980835,95.85099792480469 C7.65500020980835,95.85099792480469 4.309000015258789,87.2770004272461 4.309000015258789,87.2770004272461 C4.309000015258789,87.2770004272461 0.9629999995231628,78.5979995727539 0.9629999995231628,78.5979995727539 C0.9629999995231628,78.5979995727539 0.9110000133514404,78.44100189208984 0.9110000133514404,78.44100189208984 C0.9110000133514404,78.44100189208984 1.0149999856948853,78.44100189208984 1.0149999856948853,78.44100189208984 C1.0149999856948853,78.44100189208984 10.112000465393066,74.88600158691406 10.112000465393066,74.88600158691406 C10.112000465393066,74.88600158691406 13.352999687194824,83.1989974975586 13.352999687194824,83.1989974975586 C13.352999687194824,83.1989974975586 17.378999710083008,93.65499877929688 17.378999710083008,93.65499877929688 C17.69300079345703,94.38700103759766 16.961000442504883,95.06700134277344 16.229000091552734,94.75299835205078z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(60,144,220)" fill-opacity="1" d=" M7.458000183105469,75.91300201416016 C7.458000183105469,75.91300201416016 14.477999687194824,93.99199676513672 14.477999687194824,93.99199676513672 C14.477999687194824,93.99199676513672 12.553999900817871,93.13400268554688 12.553999900817871,93.13400268554688 C12.107000350952148,92.93499755859375 11.583999633789062,93.13800048828125 11.388999938964844,93.58599853515625 C11.388999938964844,93.58599853515625 10.513999938964844,95.5979995727539 10.513999938964844,95.5979995727539 C10.513999938964844,95.5979995727539 3.4709999561309814,77.46099853515625 3.4709999561309814,77.46099853515625 C3.4709999561309814,77.46099853515625 7.458000183105469,75.91300201416016 7.458000183105469,75.91300201416016z"></path></g></g><g opacity="0.15" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(24,30,30)" fill-opacity="1" d=" M0.9629999995231628,78.44100189208984 C0.9629999995231628,78.44100189208984 1.0149999856948853,78.44100189208984 1.0149999856948853,78.44100189208984 C1.0149999856948853,78.44100189208984 10.112000465393066,74.88600158691406 10.112000465393066,74.88600158691406 C10.112000465393066,74.88600158691406 13.352999687194824,83.1989974975586 13.352999687194824,83.1989974975586 C12.20300006866455,83.04199981689453 11,82.6240005493164 9.850000381469727,82.15299987792969 C9.118000030517578,81.89199829101562 8.125,81.4739990234375 7.498000144958496,81.36900329589844 C7.184000015258789,81.89199829101562 6.765999794006348,82.83300018310547 6.452000141143799,83.45999908447266 C5.876999855041504,84.76699829101562 5.25,86.23100280761719 4.309000015258789,87.2770004272461 C4.309000015258789,87.2770004272461 0.9629999995231628,78.5979995727539 0.9629999995231628,78.5979995727539"></path></g></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(78,166,236)" fill-opacity="1" d=" M21.37700080871582,66.00199890136719 C21.37700080871582,68.31600189208984 14.77400016784668,69.2979965209961 13.937999725341797,71.31099700927734 C13.071999549865723,73.39600372314453 17.007999420166016,78.75599670410156 15.434000015258789,80.3280029296875 C13.861000061035156,81.89900207519531 8.505000114440918,77.95700073242188 6.418000221252441,78.8219985961914 C4.40500020980835,79.65599822998047 3.4200000762939453,86.25800323486328 1.1050000190734863,86.25800323486328 C-1.2100000381469727,86.25800323486328 -2.194999933242798,79.65599822998047 -4.208000183105469,78.8219985961914 C-6.295000076293945,77.95700073242188 -11.651000022888184,81.89900207519531 -13.223999977111816,80.3280029296875 C-14.79800033569336,78.75599670410156 -10.862000465393066,73.39600372314453 -11.727999687194824,71.31099700927734 C-12.564000129699707,69.2979965209961 -19.16699981689453,68.31600189208984 -19.16699981689453,66.00199890136719 C-19.16699981689453,63.68600082397461 -12.5649995803833,62.70100021362305 -11.729999542236328,60.6870002746582 C-10.86400032043457,58.5989990234375 -14.802000045776367,53.2400016784668 -13.229000091552734,51.66699981689453 C-11.656000137329102,50.09400177001953 -6.297999858856201,54.03300094604492 -4.210000038146973,53.16699981689453 C-2.196000099182129,52.332000732421875 -1.2109999656677246,45.72999954223633 1.1050000190734863,45.72999954223633 C3.4210000038146973,45.72999954223633 4.406000137329102,52.332000732421875 6.420000076293945,53.16699981689453 C8.508000373840332,54.03300094604492 13.866999626159668,50.095001220703125 15.4399995803833,51.667999267578125 C17.01300048828125,53.24100112915039 13.074000358581543,58.5989990234375 13.9399995803833,60.6870002746582 C14.774999618530273,62.70100021362305 21.37700080871582,63.68600082397461 21.37700080871582,66.00199890136719z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(60,144,220)" fill-opacity="1" d=" M14.651000022888184,65.99400329589844 C14.651000022888184,73.46800231933594 8.588000297546387,79.53099822998047 1.1139999628067017,79.53099822998047 C-6.377999782562256,79.53099822998047 -12.440999984741211,73.46800231933594 -12.440999984741211,65.99400329589844 C-12.440999984741211,58.52000045776367 -6.377999782562256,52.457000732421875 1.1139999628067017,52.457000732421875 C8.588000297546387,52.457000732421875 14.651000022888184,58.52000045776367 14.651000022888184,65.99400329589844z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(235,238,247)" fill-opacity="1" d=" M12.909000396728516,65.99400329589844 C12.909000396728516,72.50599670410156 7.625,77.79000091552734 1.1130000352859497,77.79000091552734 C-5.414999961853027,77.79000091552734 -10.699000358581543,72.50599670410156 -10.699000358581543,65.99400329589844 C-10.699000358581543,59.481998443603516 -5.414999961853027,54.198001861572266 1.1130000352859497,54.198001861572266 C7.625,54.198001861572266 12.909000396728516,59.481998443603516 12.909000396728516,65.99400329589844z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(218,223,243)" fill-opacity="1" d=" M9.45199966430664,65.99400329589844 C9.45199966430664,70.5989990234375 5.716000080108643,74.33499908447266 1.1109999418258667,74.33499908447266 C-3.50600004196167,74.33499908447266 -7.242000102996826,70.5989990234375 -7.242000102996826,65.99400329589844 C-7.242000102996826,61.388999938964844 -3.50600004196167,57.65299987792969 1.1109999418258667,57.65299987792969 C5.716000080108643,57.65299987792969 9.45199966430664,61.388999938964844 9.45199966430664,65.99400329589844z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(196,205,232)" fill-opacity="1" d=" M9.456999778747559,65.99800109863281 C9.456999778747559,70.59500122070312 5.7220001220703125,74.33000183105469 1.1089999675750732,74.33000183105469 C-3.503999948501587,74.33000183105469 -7.238999843597412,70.59500122070312 -7.238999843597412,65.99800109863281 C-7.238999843597412,65.64700317382812 -7.2230000495910645,65.31099700927734 -7.158999919891357,64.97599792480469 C-6.664000034332275,69.09400177001953 -3.1530001163482666,72.27100372314453 1.1089999675750732,72.27100372314453 C5.370999813079834,72.27100372314453 8.881999969482422,69.09400177001953 9.376999855041504,64.97599792480469 C9.440999984741211,65.31099700927734 9.456999778747559,65.64700317382812 9.456999778747559,65.99800109863281z"></path></g><g opacity="1" transform="matrix(1,0,0,1,0,0)"><g opacity="1" transform="matrix(1,0,0,1,0,0)"><path fill="rgb(255,255,255)" fill-opacity="1" d=" M3.6050000190734863,68.70899963378906 C3.184000015258789,69.12999725341797 2.617000102996826,69.4010009765625 1.906000018119812,69.52200317382812 C1.906000018119812,69.52200317382812 1.906000018119812,70.16899871826172 1.906000018119812,70.16899871826172 C1.906000018119812,70.37300109863281 1.843999981880188,70.53900146484375 1.718999981880188,70.66400146484375 C1.593999981880188,70.78900146484375 1.4279999732971191,70.85099792480469 1.2239999771118164,70.85099792480469 C1.0269999504089355,70.85099792480469 0.8650000095367432,70.78900146484375 0.7360000014305115,70.66400146484375 C0.6069999933242798,70.53900146484375 0.5419999957084656,70.37300109863281 0.5419999957084656,70.16899871826172 C0.5419999957084656,70.16899871826172 0.5419999957084656,69.55599975585938 0.5419999957084656,69.55599975585938 C0.125,69.51799774169922 -0.27799999713897705,69.43099975585938 -0.6679999828338623,69.29399871826172 C-1.0579999685287476,69.15799713134766 -1.399999976158142,68.98400115966797 -1.6959999799728394,68.77200317382812 C-1.8170000314712524,68.69599914550781 -1.9019999504089355,68.61100006103516 -1.9509999752044678,68.51599884033203 C-2.000999927520752,68.4219970703125 -2.0250000953674316,68.302001953125 -2.0250000953674316,68.15799713134766 C-2.0250000953674316,67.96900177001953 -1.9670000076293945,67.802001953125 -1.850000023841858,67.65899658203125 C-1.7330000400543213,67.51499938964844 -1.5980000495910645,67.44200134277344 -1.4459999799728394,67.44200134277344 C-1.3029999732971191,67.44200134277344 -1.1239999532699585,67.50299835205078 -0.9120000004768372,67.6240005493164 C-0.5630000233650208,67.8280029296875 -0.23199999332427979,67.97899627685547 0.0820000022649765,68.072998046875 C0.3959999978542328,68.16799926757812 0.7250000238418579,68.21499633789062 1.065000057220459,68.21499633789062 C1.5199999809265137,68.21499633789062 1.8680000305175781,68.12999725341797 2.1110000610351562,67.95899963378906 C2.3529999256134033,67.78900146484375 2.4739999771118164,67.54900360107422 2.4739999771118164,67.23799896240234 C2.4739999771118164,67.0479965209961 2.4040000438690186,66.89299774169922 2.2639999389648438,66.77200317382812 C2.122999906539917,66.6510009765625 1.9509999752044678,66.55599975585938 1.746999979019165,66.48799896240234 C1.5420000553131104,66.41999816894531 1.246999979019165,66.33200073242188 0.8600000143051147,66.22599792480469 C0.30000001192092896,66.08300018310547 -0.16300000250339508,65.93800354003906 -0.5260000228881836,65.79399871826172 C-0.8889999985694885,65.6510009765625 -1.2009999752044678,65.42400360107422 -1.4630000591278076,65.11299896240234 C-1.7239999771118164,64.802001953125 -1.8550000190734863,64.38600158691406 -1.8550000190734863,63.862998962402344 C-1.8550000190734863,63.25 -1.6380000114440918,62.7239990234375 -1.2020000219345093,62.284000396728516 C-0.765999972820282,61.845001220703125 -0.19699999690055847,61.56399917602539 0.5080000162124634,61.44300079345703 C0.5080000162124634,61.44300079345703 0.5080000162124634,60.79600143432617 0.5080000162124634,60.79600143432617 C0.5080000162124634,60.590999603271484 0.5720000267028809,60.42599868774414 0.7009999752044678,60.30099868774414 C0.8299999833106995,60.17599868774414 0.9929999709129333,60.112998962402344 1.190000057220459,60.112998962402344 C1.3949999809265137,60.112998962402344 1.559000015258789,60.17599868774414 1.684000015258789,60.30099868774414 C1.809000015258789,60.42599868774414 1.871999979019165,60.590999603271484 1.871999979019165,60.79600143432617 C1.871999979019165,60.79600143432617 1.871999979019165,61.42100143432617 1.871999979019165,61.42100143432617 C2.552999973297119,61.512001037597656 3.194000005722046,61.76900100708008 3.7920000553131104,62.19300079345703 C3.9059998989105225,62.26900100708008 3.986999988555908,62.35599899291992 4.0370001792907715,62.45500183105469 C4.085999965667725,62.553001403808594 4.110000133514404,62.66999816894531 4.110000133514404,62.80699920654297 C4.110000133514404,62.99700164794922 4.051000118255615,63.16299819946289 3.934000015258789,63.305999755859375 C3.816999912261963,63.45000076293945 3.683000087738037,63.52299880981445 3.5309998989105225,63.52299880981445 C3.447999954223633,63.52299880981445 3.369999885559082,63.51100158691406 3.2980000972747803,63.487998962402344 C3.2260000705718994,63.46500015258789 3.125,63.41600036621094 2.996000051498413,63.34000015258789 C2.684999942779541,63.143001556396484 2.4070000648498535,62.99700164794922 2.1610000133514404,62.89799880981445 C1.9149999618530273,62.79999923706055 1.6139999628067017,62.75 1.2580000162124634,62.75 C0.8489999771118164,62.75 0.5210000276565552,62.840999603271484 0.2750000059604645,63.02199935913086 C0.028999999165534973,63.20399856567383 -0.09399999678134918,63.446998596191406 -0.09399999678134918,63.75 C-0.09399999678134918,63.96200180053711 -0.020999999716877937,64.13400268554688 0.12200000137090683,64.26699829101562 C0.26600000262260437,64.39900207519531 0.44699999690055847,64.50299835205078 0.6669999957084656,64.5790023803711 C0.8870000243186951,64.65499877929688 1.1929999589920044,64.74199676513672 1.5870000123977661,64.83999633789062 C2.140000104904175,64.97699737548828 2.5940001010894775,65.11399841308594 2.946000099182129,65.25499725341797 C3.2980000972747803,65.3949966430664 3.5999999046325684,65.61900329589844 3.8540000915527344,65.9260025024414 C4.10699987411499,66.23200225830078 4.235000133514404,66.64299774169922 4.235000133514404,67.15799713134766 C4.235000133514404,67.77200317382812 4.025000095367432,68.28900146484375 3.6050000190734863,68.70899963378906z"></path></g></g></g></g></g></g></svg>-->
        <button id="start-game" class="btn shadow">
          <span v-if="isLogin" @click="startGame">
            👈 برای شروع ضربه بزنید 👉
          </span>
          <span v-else @click="showLogin = true" data-toggle="modal" data-target="#loginModal">برای شروع وارد
            شوید</span>
        </button>
      </div>
      <div id="content" class="d-flex flex-column justify-content-center align-items-center mx-auto text-white py-5">
        <p class="text-center">
          ۱۰ سالگی بندیتو، بهونه‌ زیبایی برای جشن گرفتن با شما! 🎉
        </p>
        <p class="text-center">
          با شرکت در این چالش هم می‌تونی همراهیت رو به ما نشون بدی، هم توی یک
          نظرسنجی جذاب شرکت کنی و در نهایت شانس بردن
          <span class="font-bold">سکه طلا</span> داشته باشی! 💛✨
        </p>
        <p class="text-center">
          اینجا همه‌چی ساده‌ست، فقط کافیه وارد بشین و جواب بدین…
        </p>
        <!-- <p class="text-center ">
            بندیتو فروشگاه آنلاین محصولات گیاهیه مراقبت از مو و پوسته و این چالش باحال رو شروع کرده تا ببینی کدوم یک از دوستات تو رو بیشتر می‌شناسن.
  
            توی چالش دوستی بندیتو قراره هم کلی بخندی و هم علاوه بر دریافت کد تخفیف، می تونی سکه طلا ببری !😍
          </p>
          <p>🌿 ببین کدوم دوستت تو رو بهتر می‌شناسه! 🎯</p>
          <p>یه چالش باحال راه انداختیم که هم کلی می‌خندی، هم می‌تونی گردنبند طلا ببری! 😍✨</p>
          <p>چطوری؟ خیلی ساده!</p>
          <ul class="list-unstyled m-0">
            <li class="">
              <span class="p-1 ml-2 rounded">1</span>
              <p class="m-0">اول یه سری سوال جالب درباره خودت جواب میدی ، بعدش لینکتو می‌فرستی برای دوستات تا شانس برنده شدنت بیشتر بشه اول یه سری سوال فان و خنده‌دار درباره خودت جواب میدی.</p>
            </li>
            <li class="">
              <span class="p-1 ml-2 rounded">3</span>
              <p class="m-0"> به ازای هر کی که جواب بده، هم خودت و هم دوستت کلی امتیاز، بن و کد تخفیف می‌گیرین ، و امتیاز بیشتر برای قرعه کشی دریافت میکنین ، پس همین الان شروع کن که عقب نمونی .</p>
            </li>
          </ul>
          <p> 🟢 بین کیا واقعاً رفیق فابریکتن! 😎
          </p> -->
      </div>
      <!-- start questions backdrop -->
      <div class="p-3 z-index-1 question-backdrop" :class="{ open: showGame && !loading && exams, close: !showGame }"
        @click.self="closeGame" v-if="true">
        <div class="question-modal-content">
          <div>
            <form @submit.prevent="">
              <question-box @sendData="activeComponent" @submitForm="console.log" v-show="active === index + 1"
                v-for="(item, index) in exams?.data?.exam?.questions" :key="item.id" :data="item" :index="index"
                :length="exams?.data?.exam?.questions.length" />
            </form>
          </div>
          <div class="d-flex mt-3 justify-content-center align-items-center">
            <span class="mx-2">{{ active }}</span>
            از
            <span class="mx-2">{{ exams?.data?.exam?.questions?.length }}</span>
          </div>
        </div>
      </div>
      <!-- Button trigger modal -->
      <button type="button" id="showModal" class="btn btn-primary d-none" data-toggle="modal"
        data-target="#exampleModal">
        Launch demo modal
      </button>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p class="px-3 text-center">🎉 تبریک! 🎉</p>
              <p class="px-3 text-center">
                تو مرحله پایانی رو با موفقیت رد کردی 👏
              </p>
              <p class="px-3 text-center" v-if="correctCounts">
                <!-- {{ `شما از مجموع ${correctCounts.correct+correctCounts.incorrect} سوال ${correctCounts.correct} پاسخ درست و ${correctCounts.incorrect} پاسخ نادرست داده اید` }} -->
                {{ `تعداد سوالات درست ${correctCounts?.correct} ، تعداد سوالات غلط ${correctCounts?.incorrect}` }}
              </p>
              <ul class="list-group" v-if="
                examReward &&
                examReward?.gamificationResponse?.gameRewardObjects
              ">
                <li class="list-group-item border-0 d-flex align-items-baseline justify-content-center" :style="{
                  order: `${item.reward_type == 'coupon_percentage' ? 1 : 0}`,
                  gap: '15px',
                }" v-for="item in examReward?.gamificationResponse
                  ?.gameRewardObjects" :key="item.id">
                  <div v-if="item.reward_type == 'score'" class="message-score text-center" v-html="handleRewardType(item.reward_type, item?.reward_value)
                    "></div>

                  <p v-else>
                    {{ handleRewardType(item.reward_type, item?.reward_value) }}
                  </p>
                  <button v-if="item.reward_type == 'coupon_percentage'" class="btn btn-sm rounded text-white"
                    id="copyLink" @click="copyLink(percentageCode)">
                    کپی کد تخفیف
                  </button>
                </li>
                <li class="list-group-item border-0 align-items-baseline">
                  <p class="text-center">
                    🎁😍 و وارد قرعه‌کشی <strong>سکه طلای بندیتو</strong> شدی ✨
                  </p>
                  <p class="text-center">اما این همه ماجرا نیست...</p>
                </li>
                <template v-for="item in examReward?.gamificationResponse
                  ?.gameRewardObjects">
                  <li v-if="item.reward_type == 'score'" :key="item.id"
                    class="list-group-item border-0 d-flex align-items-baseline justify-content-center" :style="{
                      order: `${item.reward_type == 'coupon_percentage' ? 1 : 0
                        }`,
                      gap: '15px',
                    }">
                    <div class="message-score text-center" v-html="handleRewardType(
                      item.reward_type,
                      item?.reward_value,
                      'theme2'
                    )
                      "></div>
                  </li>
                </template>

                <li class="list-group-item border-0" style="order: 1" v-if="inviteLinkForCustomer?.length">
                  <p class="text-center">
                    <small>حالا این لینک رو برای دوستت بفرست و در چالش شرکت کنید تا
                      برنده سکه طلا 🟡 بشین !</small>
                  </p>
                  <div id="linkBox" class="d-flex align-items-center">
                    <strong v-if="inviteLinkForCustomer.length > 0">
                      {{ inviteLinkForCustomer }}
                    </strong>
                    <button class="btn btn-sm rounded text-white" id="copyLink"
                      @click="copyLink(inviteLinkForCustomer)">
                      کپی لینک
                    </button>
                  </div>
                  <!--                  <p id="invite-link text-wrap" @click="copyInviteLink"><small>{{ inviteLinkForCustomer }}</small></p>-->
                </li>
              </ul>
            </div>

            <div class="modal-footer border-top-0">
              <button type="button" class="btn btn-block btn-outline-danger" data-dismiss="modal">
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bonus-loader v-if="loader || loading" />
    <RespLoginModal />
    <div class="bottom-image">
      <img class="glass-mob " src="../../../../assets/images/game/birthday/Asset9.png" alt="glass-mob" />
      <img class="glass " src="../../../../assets/images/game/birthday/Asset10.png" alt="glass" />
    </div>

    <div v-if="ErrorflagReq" class="error-box" @click.self="closeModal">
      <div class="content">
        <button class="close-btn-error-box" @click="closeModal">
          <closeIcon />
        </button>
        <h3 class="text-center">{{ ErrorMesaageReq ?? "" }}</h3>
        <div class="copy-link-box">
          <p class="text-center">
            حالا این لینک رو برای دوستت بفرست و در چالش شرکت کنید تا
            برنده سکه طلا 🟡 بشین !
          </p>
          <div id="linkBox" class="d-flex align-items-center">
            <strong>
              {{ inviteLinkCustomerError }}
            </strong>
            <button class="btn btn-sm rounded text-white" id="copyLink" @click="copyLink(inviteLinkCustomerError)">
              کپی لینک
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
"use strict";
import axios from "axios";
import closeIcon from "../../components/Icon/DeletedClubDetail.vue"
import QuestionBox from "@/parts/Front/components/panel/exam/QuestionBox.vue";
import BonusLoader from "@/parts/Front/components/panel/exam/bonusLoader.vue";
import RespLoginModal from "../../components/RespLoginModal.vue";

export default {
  components: { BonusLoader, QuestionBox, RespLoginModal, closeIcon },
  data() {
    return {
      showLogin: false,
      data: null,
      examReward: null,
      questions: [],
      examLength: null,
      correctCounts: null,
      active: 1,
      showGame: false,
      loader: false,
      inviteLinkForCustomer: "",
      percentageCode: "",
      // errorMesaage: "",
      // errorflag: false,

    };
  },
  methods: {
    closeModal() {
      this.$store.commit('front/setErrorflag', false)

    },
    copyLink(link) {
      try {
        navigator.clipboard.writeText(link);
        this.$root.notify("لینک با موفقیت کپی شد", "success");
      } catch (error) { }
    },
    startGame() {
      this.questions.length = 0;
      this.active = 1;
      this.showGame = true;
      // document.body.classList.add("overflow-hidden");
      this.$store.dispatch(
        "front/getQuestionsGame",
        this.$route.params.slug ? this.$route.params.slug : null
      );
    },
    closeGame() {
      this.showGame = false;
      // document.body.classList.remove("overflow-hidden");
    },
    winner() {
      var confetti = {
        maxCount: 150,
        speed: 2,
        frameInterval: 15,
        alpha: 1,
        gradient: !1,
        start: null,
        stop: null,
        toggle: null,
        pause: null,
        resume: null,
        togglePause: null,
        remove: null,
        isPaused: null,
        isRunning: null,
      };
      !(function () {
        (confetti.start = s),
          (confetti.stop = w),
          (confetti.toggle = function () {
            e ? w() : s();
          }),
          (confetti.pause = u),
          (confetti.resume = m),
          (confetti.togglePause = function () {
            i ? m() : u();
          }),
          (confetti.isPaused = function () {
            return i;
          }),
          (confetti.remove = function () {
            stop(), (i = !1), (a = []);
          }),
          (confetti.isRunning = function () {
            return e;
          });
        var t =
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimationFrame,
          n = [
            "rgba(30,144,255,",
            "rgba(107,142,35,",
            "rgba(255,215,0,",
            "rgba(255,192,203,",
            "rgba(106,90,205,",
            "rgba(173,216,230,",
            "rgba(238,130,238,",
            "rgba(152,251,152,",
            "rgba(70,130,180,",
            "rgba(244,164,96,",
            "rgba(210,105,30,",
            "rgba(220,20,60,",
          ],
          e = !1,
          i = !1,
          o = Date.now(),
          a = [],
          r = 0,
          l = null;

        function d(t, e, i) {
          return (
            (t.color =
              n[(Math.random() * n.length) | 0] + (confetti.alpha + ")")),
            (t.color2 =
              n[(Math.random() * n.length) | 0] + (confetti.alpha + ")")),
            (t.x = Math.random() * e),
            (t.y = Math.random() * i - i),
            (t.diameter = 10 * Math.random() + 5),
            (t.tilt = 10 * Math.random() - 10),
            (t.tiltAngleIncrement = 0.07 * Math.random() + 0.05),
            (t.tiltAngle = Math.random() * Math.PI),
            t
          );
        }

        function u() {
          i = !0;
        }

        function m() {
          (i = !1), c();
        }

        function c() {
          if (!i)
            if (0 === a.length)
              l.clearRect(0, 0, window.innerWidth, window.innerHeight), null;
            else {
              var n = Date.now(),
                u = n - o;
              (!t || u > confetti.frameInterval) &&
                (l.clearRect(0, 0, window.innerWidth, window.innerHeight),
                  (function () {
                    var t,
                      n = window.innerWidth,
                      i = window.innerHeight;
                    r += 0.01;
                    for (var o = 0; o < a.length; o++)
                      (t = a[o]),
                        !e && t.y < -15
                          ? (t.y = i + 100)
                          : ((t.tiltAngle += t.tiltAngleIncrement),
                            (t.x += Math.sin(r) - 0.5),
                            (t.y +=
                              0.5 * (Math.cos(r) + t.diameter + confetti.speed)),
                            (t.tilt = 15 * Math.sin(t.tiltAngle))),
                        (t.x > n + 20 || t.x < -20 || t.y > i) &&
                        (e && a.length <= confetti.maxCount
                          ? d(t, n, i)
                          : (a.splice(o, 1), o--));
                  })(),
                  (function (t) {
                    for (var n, e, i, o, r = 0; r < a.length; r++) {
                      if (
                        ((n = a[r]),
                          t.beginPath(),
                          (t.lineWidth = n.diameter),
                          (i = n.x + n.tilt),
                          (e = i + n.diameter / 2),
                          (o = n.y + n.tilt + n.diameter / 2),
                          confetti.gradient)
                      ) {
                        var l = t.createLinearGradient(e, n.y, i, o);
                        l.addColorStop("0", n.color),
                          l.addColorStop("1.0", n.color2),
                          (t.strokeStyle = l);
                      } else t.strokeStyle = n.color;
                      t.moveTo(e, n.y), t.lineTo(i, o), t.stroke();
                    }
                  })(l),
                  (o = n - (u % confetti.frameInterval))),
                requestAnimationFrame(c);
            }
        }

        function s(t, n, o) {
          var r = window.innerWidth,
            u = window.innerHeight;
          window.requestAnimationFrame =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function (t) {
              return window.setTimeout(t, confetti.frameInterval);
            };
          var m = document.getElementById("confetti-canvas");
          null === m
            ? ((m = document.createElement("canvas")).setAttribute(
              "id",
              "confetti-canvas"
            ),
              m.setAttribute(
                "style",
                "display:block;z-index:124000;pointer-events:none;position:fixed;top:0"
              ),
              document.body.prepend(m),
              (m.width = r),
              (m.height = u),
              window.addEventListener(
                "resize",
                function () {
                  (m.width = window.innerWidth),
                    (m.height = window.innerHeight);
                },
                !0
              ),
              (l = m.getContext("2d")))
            : null === l && (l = m.getContext("2d"));
          var s = confetti.maxCount;
          if (n)
            if (o)
              if (n == o) s = a.length + o;
              else {
                if (n > o) {
                  var f = n;
                  (n = o), (o = f);
                }
                s = a.length + ((Math.random() * (o - n) + n) | 0);
              }
            else s = a.length + n;
          else o && (s = a.length + o);
          for (; a.length < s;) a.push(d({}, r, u));
          (e = !0), (i = !1), c(), t && window.setTimeout(w, t);
        }

        function w() {
          e = !1;
        }
      })();
      // custom js
      confetti.start();
      setTimeout(confetti.stop, 5000);
    },
    activeComponent(event, op) {
      if (this.active <= this.examLength) {
        if (op == "+") {
          this.active += 1;
        }
      }
      if (this.active > 1) {
        if (op == "-") {
          this.active -= 1;
        }
      }
      if (event) {
        if (
          !this.questions.filter(
            (item) => item.question_id == event.question_id
          )?.length
        ) {
          this.questions.push(event);
        }
      }
      if (
        this.active == this.examLength &&
        this.questions.length == this.examLength
      ) {
        this.fetchData();
      }
    },
    async fetchData() {
      //   const objIds = Object.values(this.questions).map(item => (item.question_id));
      //   const missingItems = questions.filter(item => {
      //     if (!objIds.includes(item.id)) {
      //       return item.id
      //     }
      //   });
      let formData = new FormData();
      this.questions.forEach((item, index) => {
        formData.append(`answers[${index}][question_id]`, item.question_id);
        formData.append(
          `answers[${index}][selected_option_id]`,
          item.answer_id
        );
      });
      try {
        this.loader = true;
        this.showGame = false;
        this.active = 1;

        await axios
          .post(
            `/customer/games/birthday${this.$route.params.slug ? `/second-level/${this.$route.params.slug}` : ''}`, formData
          )
          .then((response) => {
            console.log(response.data, 'response.data');
            this.examReward = response.data.data;
            this.inviteLinkForCustomer =
              response?.data?.data?.inviteLinkForCustomer;
            this.correctCounts = response?.data?.data?.correctCounts;
            // console.log(123,this.examReward.gamificationResponse.reward.coupon_percentage.length > 0);

            // this.percentageCode = this.examReward.gamificationResponse.reward.coupon_percentage.length > 0
            // ? this.examReward.gamificationResponse.reward.coupon_percentage[0].code : "test";
            // console.log(123456,percentageCode);

            document.querySelector("button#showModal").click();
            // this.showMessage(response.data.data, true)
            this.questions.length = 0;
            this.active = 1;
            this.winner();
          })
          .catch((error) => {
            console.log(error.response.data.message, 123);
            // this.errorMesaage = error.response.data.message
            // this.errorflag = true
            this.showMessage(error.response.data.message, false);
          });
      } catch (e) {
        console.log(e, 1234);
      } finally {
        this.loader = false;
      }
    },
    showMessage(msg, mode) {
      window.swal({
        title: msg,
        icon: mode ? "success" : "error",
        showConfirmButton: true,
        dangerMode: true,
        confirmButtonText: "باشه",
      });
    },
    handleRewardType(rewardType, value, type) {
      if (rewardType == "nothing") {
        return ` این بار شانس باهات یار نبود 😂😉`;
      } else if (rewardType == "gift_wallet") {
        return ` ${Number(value).toLocaleString()} تومان اعتبار رایگان   `;
      } else if (rewardType == "coupon_flat") {
        return `  ${Number(value).toLocaleString()} تومان کد تخفیف  `;
      } else if (rewardType == "score" && type == "theme2") {

        return `
        با هر دوستی که دعوت کنی و توی چالش شرکت کنه ،
<b> ${Number(
          value
        ).toLocaleString()} امتیاز دیگه هدیه می‌گیری!</b> 🔥🌸
        `
      } else if (rewardType == "score") {
        // return ` ${Number(value).toLocaleString()} امتیاز ، امتیاز باشگاه مشتریان  `
        // return `✅ همین الان <strong> ${Number(value).toLocaleString()} امتیاز باشگاه مشتریان گرفتی </strong>`
        return ` ✅ همین الان <strong> ${Number(
          value
        ).toLocaleString()} امتیاز باشگاه مشتریان </strong> گرفتی`;
      } else if (rewardType == "bon") {
        return ` ${Number(value).toLocaleString()} عدد بن باشگاه مشتریان  `;
      } else if (rewardType == "coupon_percentage") {
        return `کد تخفیف ${Number(
          value
        ).toLocaleString()} % : best شدین 🎁😍🌸`;
      }
    },
    copyInviteLink() {
      const element = document.getElementById("invite-link");
      element.addEventListener("click", () => {
        element.select();
        const text = element.innerText; // متن داخل عنصر
        navigator.clipboard.writeText(text); // کپی متن به کلیپ بورد);
      });
    },
  },
  computed: {
    ErrorflagReq() {

      return this.$store.getters["front/getErrorflag"];
    },
    ErrorMesaageReq() {

      return this.$store.getters["front/getErrorMesaage"];
    },
    exams() {
      this.examLength =
        this.$store.getters[
          "front/getQuestionsGame"
        ]?.data?.exam?.questions?.length;
      return this.$store.getters["front/getQuestionsGame"];
    },
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    loading() {
      return this.$store.getters["front/getQuestionsGameStatus"];
    },
    inviteLinkCustomerError() {
      if (
        this.$store.getters["front/getHomeData"] != null &&
        this.$store.getters["front/getHomeData"].user.user.invite_code != null
      ) {
        let url = `https://benedito.ir/games/birthday/${this.$store.getters["front/getHomeData"].user.user.invite_code}`
        return url;
      } else {
        return "";
      }
    },
  },
  created() {
    // this.$store.dispatch("front/getExamGame",this.$route.params.slug ?this.$route.params.slug :null);
  },
  watch: {
    "this.examLength"(newVal) {
      if (newVal) {
        this.examLength?.length ? (this.showGame = true) : "";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.error-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0000006a;
  display: grid;
  place-items: center;
  z-index: 100;
}

.error-box .content {
  width: 500px;
  padding: 1.5rem;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border-radius: 16px;
}

.error-box .content h3 {
  font-size: 22px;
}

.close-btn-error-box {
  border: unset;
  background-color: unset;
  align-self: flex-end;
}

.copy-link-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media only screen and (max-width:768px) {
  .error-box .content {
    width: 90%;
  }

  .error-box .content h3 {
    font-size: 18px;
  }

  .copy-link-box p {
    font-size: 14px;

  }
}

.container {
  max-width: 1200px !important;
}

.message-score span {
  font-weight: 700;
}

.brand {
  img {
    width: 10%;
    position: relative;
    top: 13px;

    &:first-child {
      width: 40px;
      margin-left: 1%;
    }
  }
}

img.heart {
  width: 90px;
  position: absolute;
  left: 0;
  right: 0;
  transform: translate(50%, -50%);
}

.bottom-image {
  display: flex;
  justify-content: center;
  align-items: center;
  /*position: absolute;
  bottom: 0;*/
  width: 100%;

  .glass {
    width: 100%;

    justify-self: center;
  }

}

.bottom-image .glass-mob {
  display: none;
}

.shape {
  position: absolute;
  width: 90px;
  height: auto;

  &:nth-child(even) {
    animation: shape-move 5s infinite forwards alternate linear;
  }

  &:nth-child(odd):not(.shape-5) {
    animation: shape-move 5s infinite alternate linear;
  }

  &.shape-5 {
    animation: shape-move-shape5 5s infinite alternate linear !important;
  }

  &.shape-1 {
    top: 13%;
    left: 1%;
  }

  &.shape-2 {
    top: 26%;
    right: 1%;
  }

  &.shape-2-2 {
    top: 30%;
    right: -1%;

  }

  &.shape-3 {
    top: 40%;
    left: 1%;
  }

  &.shape-4 {
    top: 55%;
    right: 1%;
  }

  &.shape-5 {
    top: 70%;
    left: 3%;
    width: 100px !important;
    z-index: 1;
    transform: translate(0) rotate(-13deg) !important;

  }

  &.shape-5-1 {
    top: 70%;
    left: 1%;
    width: 60px !important;
  }

  &.shape-6 {
    top: 85%;
    right: 1%;
  }
}

#start-game {
  position: relative;
  //width: clamp(100px, 20%, 200px);
  height: 60px;
  border-radius: 10px;
  font-size: 1.5rem;
  color: #ce1485;
  font-weight: bold;
  background: white;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10%;
    height: 10%;
    background: yellow;
    transform: translate(-50%, -50%);
    animation: scale 2s infinite linear forwards;
  }

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10%;
    height: 10%;
    background: yellow;
    transform: translate(-50%, -50%);
    animation: scale 2.5s infinite 0.5s linear forwards;
  }

  @keyframes scale {
    from {
      z-index: -1;
      width: 30%;
      height: 30%;
      border-radius: 200px;
      opacity: 0.4;
    }

    to {
      z-index: -1;
      width: 180%;
      height: 180%;
      border-radius: 200px;
      opacity: 0;
    }
  }
}

.games {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

section {
  width: 100%;
  position: relative;
  background: url("../../../../assets/images/game/exam/background.png") repeat-y;
  background-size: cover;

  #background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    height: 100%;
    object-fit: cover;

    @media screen and (max-width: 768px) {
      object-fit: fill;
    }
  }


}

#content {
  max-width: 800px;

  p {
    line-height: 2;
  }

  ul {
    li {
      display: flex;
      align-items: start;
      line-height: 2.5;
      //justify-content: center;

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        font-size: 12px;
        background: #01a6ed;
        color: white;
        border: 2px solid transparent;
      }
    }
  }
}

.question-backdrop {
  visibility: hidden;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(3px);
  padding: 20px;
  width: 100%;
  margin: auto;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;

  &.close {
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.5s ease-out;
  }

  &.open {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.5s linear;
  }

  .question-modal-content {
    background: white;
    height: fit-content;
    border-radius: 10px;
    box-shadow: 0 0 1.5rem 5px rgba(0, 0, 0, 0.3);
    padding: 30px;
    width: 80%;
    max-width: 768px;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
}

#invite-link {
  text-align: end;
}

/* winner animation */

//* {
//  padding: 0;
//  margin: 0;
//  font-family: 'Raleway', sans-serif;
//}

html {
  font-size: 62.5%;
}

.content .trophy img {
  display: block;
  margin: auto;
  max-width: 128px;
  filter: drop-shadow(0 0 4px #000);
  transition: 0.5s;
  animation: animate 2s linear infinite;
}

@keyframes animate {
  0% {
    transform: scale(1);
  }

  25% {
    transform: scale(1.1);
  }

  50% {
    transform: scale(1);
  }

  75% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1.1);
  }
}

@keyframes shape-move-shape5 {
  0% {
    transform: translate(0) rotate(-13deg);
  }

  25% {
    transform: translate(0, 10%) rotate(-13deg);
  }

  50% {
    transform: translate(10%, 10%) rotate(-13deg);
  }

  75% {
    transform: translate(10%, 0) rotate(-13deg);
  }

  100% {
    transform: translate(0) rotate(-13deg);
  }
}

@keyframes shape-move {
  0% {
    transform: translate(0);
  }

  25% {
    transform: translate(0, 10%);
  }

  50% {
    transform: translate(10%, 10%);
  }

  75% {
    transform: translate(10%, 0);
  }

  100% {
    transform: translate(0);
  }
}

.content .text h1 {
  font-weight: 900;
  font-size: 8rem;
  color: #222324;
  text-shadow: 8px 0 0 #fabe2c;
}

#developerPra {
  position: fixed;
  bottom: 4rem;
  right: 4rem;
  font-size: 4rem;
  color: rgba(0, 0, 0, 0.7);
}

.modal-content {
  z-index: 1100 !important;
}

.bottom-image img {
  max-width: 100%;
  width: 100%;
}

@media screen and (max-width: 1250px) {
  .container {
    max-width: 1000px !important;
  }
}

@media screen and (max-width: 1050px) {
  .container {
    max-width: 90% !important;
  }
}

@media screen and (max-width: 1200px) {
  .top-image {
    img {
      width: 50% !important;
    }
  }

  .shape {
    width: 10% !important;
  }
}

@media screen and (max-width: 996px) {
  #start-game {
    font-size: 16px;
    border-radius: 5px;
    height: 45px;
  }

  .exam-container {
    overflow: hidden;
  }

  .shape {
    width: 50px !important;

    &.shape-1 {
      top: 5%;
      left: 5%;
    }

    &.shape-2 {
      top: 18%;
      right: 5%;
    }

    &.shape-2-2 {
      top: 20%;
      right: 5%;

    }

    &.shape-3 {
      top: 30%;
      left: 5%;
    }

    &.shape-4 {
      top: 45%;
      right: 5%;
    }

    &.shape-5 {
      top: 60%;
      left: 9%;
      width: 70px !important;
    }

    &.shape-5-1 {
      top: 60%;
      left: 5%;
      width: 40px !important;
    }

    &.shape-6 {
      top: 78%;
      right: 5%;
    }
  }
}

@media screen and (max-width: 768px) {
  .shape.shape-2 {
    top: 18%;
    right: 5%;
    width: 70px !important;

  }

  #start-game {
    width: fit-content;
    padding: 0.5rem 0.8rem;
    font-size: 16px;
    border-radius: 5px;
  }

  .shape.shape-4 {
    top: 93%;
    left: 5%;
  }

  .shape.shape-3 {
    top: 15%;
    left: 5%;
  }

  .shape.shape-2-2 {
    top: 22%;
    right: 0%;
    width: 70px !important;

  }

  .shape.shape-5 {
    top: 89%;
    left: 9%;
    width: 70px !important;
  }

  .shape.shape-5-1 {
    top: 89%;
    left: 4%;
    width: 40px !important;
  }

  .bottom-image .glass-mob {
    display: flex;
  }

  .bottom-image .glass {
    display: none;
  }
}

@media screen and (max-width: 500px) {
  .bottom-image img {
    max-width: 100%;
    width: 100%;

  }
}

/*invite link*/
#link {
  --rp: 8px;
}

#scores table tbody tr td,
#scores table thead tr th {
  white-space: nowrap !important;
}

div#linkBox strong {
  background: #e3e3e3;
  padding: 4px 10px;
  border-radius: 5px;
  display: flex;
  align-items: baseline;
}

#copyLink {
  font-size: 14px;
  background: var(--color-theme);
}

div#linkBox {
  width: max-content;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px dotted;
  padding: 10px;
  border-radius: 10px;
}

@media (max-width: 580px) {
  #link {
    --rp: 4px;
  }

  #copyLink {
    font-size: 14px;
  }

  div#linkBox strong {
    font-size: 10px;
    padding: 6px;
  }

  div#linkBox {
    padding: 5px;
    border-radius: 5px;
    gap: 8px;
  }
}

/*invite link*/
</style>
